// extracted by mini-css-extract-plugin
export default {"jumpToBottom":"JumpToBottom-module__jumpToBottom--M3pZ0"};